<template>
    <div class="d-flex flex-column">
        <h1 class="text-center text-lg-left mb-8">{{ $t('pages.psychologist-register.title') }}</h1>
        <p class="text-center text-lg-left text-gold">{{ $t('pages.psychologist-register.sub_title') }}</p>

        <el-form v-if="!show_invite_success" @submit="submit" class="my-16 my-lg-auto">

            <template slot="default">

                <el-error class="mb-16" :error="server_error"></el-error>

                <div class="form-row">
                    <div class="col-12 col-lg-6">
                        <el-input v-model="data.first_name" type="text" rule="required" :name="$t('form-elements.first_name')" :label="$t('form-elements.first_name')" :placeholder="$t('form-elements.first_name_placeholder')"></el-input>
                    </div>
                    <div class="col-12 col-lg-6">
                        <el-input v-model="data.last_name" type="text" rule="required" :name="$t('form-elements.last_name')" :label="$t('form-elements.last_name')" :placeholder="$t('form-elements.last_name_placeholder')"></el-input>
                    </div>
                    <div class="col-12">
                        <el-input v-model="data.email" type="email" rule="required|email" :name="$t('form-elements.email')" :label="$t('form-elements.email')" :placeholder="$t('form-elements.email_placeholder')"></el-input>
                    </div>

                    <div class="col-12 col-lg-6">
                        <el-input v-model="data.password" type="password" rule="required" :name="$t('form-elements.password')" :label="$t('form-elements.password')" :placeholder="$t('form-elements.password_placeholder')"> </el-input>
                    </div>
                    <div class="col-12 col-lg-6">
                        <el-input v-model="data.password_repeat" type="password" rule="required" :name="$t('form-elements.password_repeat')" :label="$t('form-elements.password_repeat')" :placeholder="$t('form-elements.password_repeat_placeholder')"> </el-input>
                    </div>

                    <div class="col-12 col-xl-9 mb-32">
                        <p-check v-model="data.accepted_terms" class="p-curve p-svg p-jelly small text-wrap" color="primary" name="check" rule="required" required>
                            <i-check slot="extra" class="svg svg-icon"></i-check>
                            {{ $t('pages.psychologist-register.accepted_terms') }}
                        </p-check>
                    </div>

                </div>
            </template>

            <template slot="footer">
                <button class="btn btn-primary btn-block btn-lg-inline d-block d-lg-flex mb-8 mb-xl-0" v-bind:class="{ disabled : loading }">
                    {{ $t('pages.psychologist-register.cta_submit') }}
                    <template v-if="loading">
                        <i-loader class="ml-2 i-20 my-auto"></i-loader>
                    </template>
                    <template v-if="success">
                        <i-check class="ml-2 i-20 my-auto"></i-check>
                    </template>
                </button>
            </template>

        </el-form>
        <div v-else class="mt-100">
            <i-check class="i-40 fill-primary text-center mb-16 w-100 mx-auto"></i-check>
            <h4 class="text-primary-dark text-center mb-8 fw-sb">{{ $t('pages.psychologist-register.success_title') }}</h4>
            <p class="text-center">{{ $t('pages.psychologist-register.success_sub_title') }}</p>
        </div>

    </div>
</template>

<script>
import { ElInput, ElForm, PCheck, ElError } from '@/components/forms'

//Extends
import hasForm from '@/components/forms/has-form';

export default {
    name: 'page-psychologist-register',

    mixins: [hasForm],

    components: { ElInput, ElForm, PCheck, ElError },

    data: () => ({
        show_invite_success: false,
        data: {
            first_name: '',
            last_name: '',
            email: '',
            password: '',
            locale: 'nl-BE',
            password_repeat: '',
            accepted_terms: false
        }
    }),

    mounted() {
        if (this.$route.query.token) {
            this.data.token = this.$route.query.token
        }
    },
    methods: {
        submit() {
            this.$validator.validateAll().then(res => {
                if (res) {
                    if (this.data.password !== this.data.password_repeat) {
                        this.server_error = ['repeat_password_does_not_match']
                        return
                    }
                    this.loading = true
                    this.$store.dispatch('psychologists/create', this.data).then(
                        () => {
                            if (!this.data.token) {
                                this.handleSuccess('register_psychologist')
                                this.show_invite_success = true
                            }
                            else {
                                this.$store.dispatch('user/login', { password: this.data.password, email: this.data.email }).then(
                                    () => {
                                        this.handleSuccess('register_psychologist')
                                        this.$router.push({ name: 'admin-dashboard' })
                                    },
                                    (e) => this.handleError(e)
                                )
                            }
                        },
                        (e) => this.handleError(e)
                    )
                }
            })
        }
    }
}
</script>
